import { useUI } from "providers/UIProvider"
import history from "utils/history"

import { Box, Flex } from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import MainLayout from "../MainLayout"
import LoundriesTable from "./LoundriesTable"
import LoundriesToolbar from "./LoundriesToolbar"
import { useAppContext } from "providers/AppProvider/AppProvider"

const LoundriesTemplate = () => {
  const { T } = useUI()
  const { isAdmin, laundry } = useAppContext()

  if(!isAdmin && laundry) {
    history.push(`/laundries/${laundry.id}`)
  }

    return(
        <MainLayout navigation>
        <Flex flexDirection={"column"} paddingLeft={"25px"} paddingRight={"25px"}>
          <Flex
            width={"100%"}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            {/* <Button
              leftIcon={
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"34px"}
                  width={"34px"}
                  borderRadius={"xl"}
                  border={"1px solid #E3EEFC"}
                >
                  <Icon
                    iconStyles={{ height: "17px", width: "17px" , fill: "grey" }}
                    name='arrowLeft'
                  />
                </Box>
              }
              styles={{
                width: "130px",
                height: "63px",
                fontSize: "xl",
                lineHeight: "28px",
              }}
              onClick={() => history.back()}
              text={T("loundries.page.back.button")}
              variant='solid_white'
            /> */}
            
            <Button
              leftIcon={
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  height={"34px"}
                  width={"34px"}
                  borderRadius={"xl"}
                  background={"primary"}
                >
                  <Icon
                    iconStyles={{ height: "17px", width: "17px" }}
                    name='add_person'
                  />
                </Box>
              }
              styles={{
                width: "180px",
                height: "63px",
                fontSize: "xl",
                lineHeight: "28px",
              }}
              onClick={() => history.push("/laundries/add-laundry")}
              text={T("employees.add")}
              variant='solid_white'
            />
          </Flex>
          <Box mt={"20px"}>
            <LoundriesToolbar/>
            <LoundriesTable/>
          </Box>
        </Flex>
      </MainLayout>

    )
}

export default LoundriesTemplate